<div *ngIf="showMessage" class="text-xs text-negative mt-2">
  {{errorMessage}}
</div>
